import { ref, watch } from "vue";

export default function usePercentToleranciaDialog(props, emit) {
  const resetForm = () => ({
    minima: 0,
    maxima: 0,
    applyAll: true,
  });
  const toleranciaForm = ref(resetForm());

  const resetarFormulario = () => {
    // Preserva o valor de applyAll
    const currentApplyAll = toleranciaForm.value.applyAll;
    toleranciaForm.value = {
      minima: 0,
      maxima: 0,
      applyAll: currentApplyAll
    };
  };

  const close = () => {
    props.handleClose();
  }

  const handleAplyTolerancia = () => {
    emit('apply-tolerancia', toleranciaForm.value);
    props.handleClose();
  }

  const canApplyOnly = ref(false);
  const currentSelectedCount = ref(0);

  watch(() => props.visible, (newVal) => {
    if (!newVal) return;

    // Congela o estado da seleção ao abrir para evitar pulos no radio durante o fechamento
    canApplyOnly.value = !props.isAllSelected;
    currentSelectedCount.value = props.selectedCount;

    // Ao abrir, reseta os percentuais e define o applyAll baseado na seleção atual
    toleranciaForm.value.minima = 0;
    toleranciaForm.value.maxima = 0;
    toleranciaForm.value.applyAll = props.isAllSelected;
  });

  const showMinimaWarning = ref(false);
  const showMaximaWarning = ref(false);

  watch(() => toleranciaForm.value.minima, (newVal) => {
    if (newVal < 0) {
      toleranciaForm.value.minima = 0;
      showMinimaWarning.value = true;
    } else if (newVal > 100) {
      toleranciaForm.value.minima = 100;
      showMinimaWarning.value = true;
    } else {
      showMinimaWarning.value = false;
    }
  });

  watch(() => toleranciaForm.value.maxima, (newVal) => {
    if (newVal < 0) {
      toleranciaForm.value.maxima = 0;
      showMaximaWarning.value = true;
    } else if (newVal > 100) {
      toleranciaForm.value.maxima = 100;
      showMaximaWarning.value = true;
    } else {
      showMaximaWarning.value = false;
    }
  });

  return {
    close,
    handleAplyTolerancia,
    toleranciaForm,
    resetarFormulario,
    resetForm,
    showMinimaWarning,
    showMaximaWarning,
    canApplyOnly,
    currentSelectedCount
  };
}
